var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrowdSafetyStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1621 16.624L26.5996 16.624L31.8365 9.49904L37.2871 16.624L33.7246 16.624L33.7246 24.6992L30.1621 24.6992L30.1621 16.624Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 26.5996V29.7663H26.917V26.5996C26.917 26.5996 26.917 20.2663 17.417 20.2663C7.91699 20.2663 7.91699 26.5996 7.91699 26.5996ZM12.667 12.3496C12.667 11.4102 12.9456 10.4918 13.4675 9.71065C13.9894 8.92952 14.7313 8.3207 15.5992 7.96118C16.4672 7.60167 17.4223 7.5076 18.3437 7.69088C19.2651 7.87416 20.1114 8.32655 20.7757 8.99085C21.44 9.65515 21.8924 10.5015 22.0757 11.4229C22.259 12.3443 22.1649 13.2994 21.8054 14.1674C21.4459 15.0353 20.8371 15.7772 20.056 16.2991C19.2748 16.821 18.3565 17.0996 17.417 17.0996C16.1572 17.0996 14.949 16.5992 14.0582 15.7084C13.1674 14.8176 12.667 13.6094 12.667 12.3496ZM7.60032 20.3613C6.73483 21.1598 6.03705 22.1226 5.54772 23.1937C5.0584 24.2648 4.78732 25.4226 4.75032 26.5996V29.7663H0.000324249V26.5996C0.000324249 26.5996 0.000324249 21.1371 7.60032 20.3613ZM9.50032 7.59961C9.97871 7.5999 10.4541 7.67468 10.9095 7.82128C9.98316 9.14965 9.4865 10.7302 9.4865 12.3496C9.4865 13.9691 9.98316 15.5496 10.9095 16.8779C10.4541 17.0245 9.97871 17.0993 9.50032 17.0996C8.24055 17.0996 7.03236 16.5992 6.14157 15.7084C5.25077 14.8176 4.75032 13.6094 4.75032 12.3496C4.75032 11.0898 5.25077 9.88165 6.14157 8.99085C7.03236 8.10006 8.24055 7.59961 9.50032 7.59961Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrowdSafetyStatistics);
export default __webpack_public_path__ + "static/media/icon-crowd-safety-statistics.c93f0e01947dbf6a11d347af3c815933.svg";
export { ForwardRef as ReactComponent };